import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=28d78e12&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=28d78e12&prod&lang=scss&scoped=true"
import style1 from "./uploader.vue?vue&type=style&index=1&id=28d78e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d78e12",
  null
  
)

export default component.exports